<template>
  <div id="app" :class="{ 'fix-ie': showLoader }">
    <div id="nprogress-container" />
    <ald-loader v-if="showLoader" :text="`${loaderText}...`" />
    <router-view />
    <dialog-error ref="dialogError" :config="errorConfig" />
  </div>
</template>

<script>
import DialogError from 'views/Error/Dialog';

export default {
  name: 'AldBBVAConnect',

  components: {
    DialogError
  },

  data() {
    return {
      errorConfig: {}
    };
  },

  computed: {
    showLoader() {
      return this.$store.getters['ui/dataUI']('loader');
    },

    loaderText() {
      return (
        this.$store.getters['ui/dataUI']('loaderText') || this.$t('message.generic.loadingData')
      );
    }
  },

  mounted() {
    this.$cookiebot.consentBanner();
    this.setTheme(this.$store.getters['ui/dataUI']('theme'));

    this.$store.watch(
      getters => getters.ui.theme,
      val => {
        this.setTheme(val);
      }
    );

    this.$store.watch(
      getters => getters.error,
      val => {
        if (val) {
          if (val.dialog) {
            this.errorConfig = JSON.parse(JSON.stringify(val));
            this.$refs.dialogError.show();
          } else {
            this.$router.push({ name: 'error' });
          }
          this.$store.dispatch('RESET_ERROR_PROPERTY');
        }
      }
    );
  },

  methods: {
    setTheme(theme) {
      this.$el.parentElement.className = `theme-${theme}`;
    }
  }
};
</script>
